module.exports = __webpack_public_path__ + "static/media/Email.498d21bb.png";